import { render, staticRenderFns } from "./MiniCart.vue?vue&type=template&id=5d84b850&scoped=true&"
import script from "./MiniCart.js?vue&type=script&lang=js&"
export * from "./MiniCart.js?vue&type=script&lang=js&"
import style0 from "./MiniCart.scss?vue&type=style&index=0&id=5d84b850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d84b850",
  null
  
)

/* custom blocks */
import block0 from "./MiniCart.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fheader%2FMiniCart%2FMiniCart.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports